
import { Vue } from "vue-class-component";

export default class Hal extends Vue {}
